export default "__VITE_ASSET__ee5954f6__"